import type { FormModule } from "../dashboard-app/types"

const formModule: FormModule = {
  customFields: {}
}

export default formModule